import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractReportTemplateSection from "./AbstractReportTemplateSection.js";

/**
 * Section used to render the condensed income statement for a period report.
 */
export default class IncomeStatementSection extends AbstractReportTemplateSection {
	getTitle() {
		return _("Income statement");
	}

	accept(visitor) {
		return visitor.visitIncomeStatementSection(this);
	}

	static getType() {
		return "IncomeStatementSection";
	}

	static getId() {
		return "income-statement";
	}

	static getReportId() {
		return "CondensedIncomeStatement";
	}
}
